import { render, staticRenderFns } from "./AdminPayroll.vue?vue&type=template&id=140a6e50&scoped=true&"
import script from "./AdminPayroll.vue?vue&type=script&lang=js&"
export * from "./AdminPayroll.vue?vue&type=script&lang=js&"
import style0 from "./AdminPayroll.vue?vue&type=style&index=0&id=140a6e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a6e50",
  null
  
)

export default component.exports